import React from 'react';
import styled from 'styled-components';
import I10n from '../features/i10n';
import MsxIcons from '../features/msx-icons';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
`;

const Label = styled.label`
  width: 200px;
  margin-bottom: 10px;
`;

const InputWrapper = styled.div`
  input {
    height: 40px;
    box-sizing: border-box;
    margin-bottom: 10px;
    ${props => props.showWarning ? `border: 1px solid #e47f00; margin-right: 10px;` : ``}
    outline: none;
    padding: 5px;
  }
`;

const QuantityWarningWrapper = styled.div`
  display: flex;
  align-items: center;
  color: #e47f00;
`;

const WarningLabel = styled.span`
  margin-left: 5px;
`;

const MandatoryStar = styled.span`
  color: #ED2B00;
  font-size: 14px;
  margin-left: 5px;
`;

class LicenceSelectorInput extends React.Component {

  handleKeyPress = (event) => {
    const forbiddenCharacters = ['e', 'E', '.', ',', '+', '-'];
    if (forbiddenCharacters.includes(event.key)) {
        event.preventDefault();
    }
  }

  processOverflowValue () {
    const { answer, userAnswers, setAnswer } = this.props;
    const value = userAnswers[answer.criteria];
    const MAX_VALUE = answer.limitMax != null ? answer.limitMax : 9999999;
    if (value != null && value > MAX_VALUE) {
      setAnswer(answer.criteria, MAX_VALUE);
    }
  }

  componentDidUpdate() {
    this.processOverflowValue();
  }

  componentDidMount() {
    this.processOverflowValue();
  }

  render() {
    const { answer, userAnswers, setAnswer, softwareLicencesMap, matchReference, showMandatoryOnInput } = this.props;

    const value = userAnswers[answer.criteria];

    const showWarning = matchReference && softwareLicencesMap && softwareLicencesMap[matchReference] && softwareLicencesMap[matchReference].quantity < (value || 0);

    return (
      <Container key={answer.key}>
        {answer.name && <Label>
          {I10n.getOrDefault(`screen.licence_selector.modal.answer.name.${answer.labelKey}`, answer.name)} :
          {showMandatoryOnInput && <MandatoryStar>*</MandatoryStar>}
        </Label>}
        <InputWrapper showWarning={showWarning}>
          <input
            onClick={(event) => {
              event.stopPropagation();
            }}
            type="number"
            onWheel={(e) => {
              e.target.blur();
              e.stopPropagation();
            }}
            value={value || ''}
            onKeyPress={this.handleKeyPress}
            onChange={(event) => {
              let value = event.target.value;
              const MAX_VALUE = answer.limitMax != null ? answer.limitMax : 9999999;
              if (value > MAX_VALUE) {
                value = MAX_VALUE;
              }
              setAnswer(answer.criteria, value);
            }}
          />
        </InputWrapper>
        {showWarning && <QuantityWarningWrapper>
          <MsxIcons name="alert"></MsxIcons>
          <WarningLabel>{I10n.getAndReplaceMultiple('screen.licence_selector.modal.match_reference.warning.quantity', [ matchReference, softwareLicencesMap[matchReference].quantity])}</WarningLabel>
        </QuantityWarningWrapper>}
      </Container>
    );
  }
}

export default LicenceSelectorInput;
